import { usePwaUpdater } from '@/shared/hooks/usePwaUpdater';

export function PwaAutoUpdater() {
  usePwaUpdater();
  return null;
}
